import { __makeTemplateObject } from "tslib";
import { createGlobalStyle } from '@marvelapp/styled';
// Disable screen navigation with swipe gestures (back and forward)
// Works in Chromium-based browser and Firefox, not supported by Safari yet:
// https://bugs.webkit.org/show_bug.cgi?id=176454
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n html {\n  overscroll-behavior-x: none;\n }\n"], ["\n html {\n  overscroll-behavior-x: none;\n }\n"])));
// TODO: fixme @import is not supported anymore by styled-components@v5
// const GlobalStyle = createGlobalStyle`
//   @import url('https://s3.eu-west-2.amazonaws.com/marvelapp-styleguide/fonts/fonts.css');
// `;
export default GlobalStyle;
var templateObject_1;
